import dayjs from "dayjs";

export default function ChatDate({date}) {
    return (
        <small className='px-1 text-xs text-gray-300 block'>
            {date}
        </small>
    )
}